import React from 'react';
import teamImage from '../assets/team.jpg';
import logo from '../assets/logo.jpg';

const TeamSection = () => {
  return (
    <section className="bg-white py-20" id="team">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            {/* Logo */}
            <div className="absolute -top-10 left-0 z-10">
              <img
                src={logo}
                alt="Sun Energy Logo"
                className="h-24 w-auto"
              />
            </div>
            
            {/* Team Image */}
            <div className="relative bg-blue-900 rounded-2xl overflow-hidden">
              <img
                src={teamImage}
                alt="Our Professional Team"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-orange-500 font-bold mb-4">
                DEDICATED & SERVICE-ORIENTED
              </h2>
              <h3 className="text-4xl md:text-5xl font-bold text-blue-900 mb-8">
                Our Professional<br />Team
              </h3>
            </div>

            <div className="space-y-6">
              <div>
                <p className="text-gray-800 text-xl text-left">
                  Our <span className="font-bold">Mission</span> is to accelerate Myanmar's shift from diesel-powered energy to renewable sources by offering high-quality, affordable solar panels that maximize efficiency and reduce environmental impact.
                </p>
              </div>

              <p className="text-gray-800 text-xl text-left">
                We design and manufacture durable, innovative solar PV modules tailored for diverse needs.
              </p>

              <div>
                <p className="text-gray-800 text-xl text-left">
                  Leveraging advanced technologies like <span className="font-bold">16BB N-type cells</span> and bifacial modules, we deliver solutions that meet international standards and ensure long-term performance.
                </p>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;